import React, { useEffect } from 'react'
import { fetchLmsCourses } from '../../actions'
import { useStateValue } from '@State'

export const CreateTool = () => {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    fetchLmsCourses(dispatch)
  }, [])

  const { coursenum, courseList, canvasCoursenum } = state
  let canvasName = ''
  let externalLinkEndpoint = `/links/client_canvas.create_external_launch_tool/${coursenum}/`
  if (courseList && courseList.length !== 0 && canvasCoursenum) {
    let canvasCourseMap = courseList.reduce((memo, c) => {
      memo[c.id] = c
      return memo
    }, {})
    let canvasCourse = canvasCourseMap[canvasCoursenum]
    canvasName = canvasCourse?.name ?? ''
  }

  return (
    <div className="card-myed">
      <div className="canvas-flex-wrapper">
        <div className="wrapper control-box">
          <h3>4. Create Link</h3>
          <p>
            Click the button below to create a new link to MyEducator in your
            Canvas course <span className="bold">{canvasName}</span>
          </p>

          <div className="canvas-flex-wrapper justify-left">
            <div className="nav-button-container">
              <a
                href={externalLinkEndpoint}
                className="btn btn-myed btn-primary btn-primary-myed"
              >
                Create Link <div className="fa-solid fa-chevron-right ml-2" />
              </a>
            </div>
          </div>
        </div>
        <div className="canvas-statusmarker-container">
          <img src="/static/instructor/media/canvas-logo-lms.png" />
        </div>
      </div>
    </div>
  )
}

